import type { TableColumnHeaderProps} from '@chakra-ui/react'
import { Th, useBreakpoint } from '@chakra-ui/react'

interface RowTableHeaderProps extends TableColumnHeaderProps {
  children: React.ReactNode
  icon?: React.ReactNode
}

export const RowTableHeader = ({
  children,
  icon,
  ...rest
}: RowTableHeaderProps) => {
  const breakpoint = useBreakpoint()

  const iconCellWidth = 40
  let totalWidth = breakpoint === 'base' ? 200 : breakpoint === 'sm' ? 270 : 340

  if (icon) totalWidth -= iconCellWidth

  return (
    <>
      {icon && (
        <Th pr={0} w={`${iconCellWidth}px`}>
          {icon}
        </Th>
      )}
      <Th fontSize={'md'} w={`${totalWidth}px`} {...rest}>
        {children}
      </Th>
    </>
  )
}
